module.exports = __webpack_public_path__ + "static/media/Datareport.3e5a2861.jpeg";